module.exports = __webpack_public_path__ + "static/media/33import-66.59b7bc5a.xlsx";